import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Injectable } from '@odinjs/odin';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

export interface RequestResponse {
  body: boolean;
  status: number;
}

@Injectable({})
export default class ResetPasswordService {
  static recoverPassword(emailID: string): Promise<RequestResponse> {
    return HttpService.post(APPLICATION_ENDPOINTS.EMAILSENDER_RECOVEREMAIL, {emailID}).then(response => response as RequestResponse);
  }
}
